import { IAssetItemAdjustment } from '../../interfaces/iasset-item-adjustment';
import { Item } from '../item';

export class AssetItemAdjustmentBase {
  AssetItemAdjustmentId: number;
  AssetId: number;
  ItemId: number;
  Quantity: number | null;
  AdjustmentDate: Date | null;
  Comments: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Item?: Item;

  constructor(item?: IAssetItemAdjustment) {
    if (item) {

      this.AssetItemAdjustmentId = item.AssetItemAdjustmentId;
      this.AssetId = item.AssetId;
      this.ItemId = item.ItemId;
      this.Quantity = item.Quantity;
      this.AdjustmentDate = item.AdjustmentDate ? new Date(item.AdjustmentDate) : null;
      this.Comments = item.Comments;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Item = new Item(item.Item);
    }
  }
}